'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

interface BannerProps {
  banners: Array<{
    id: number;
    banner_post_click_url: string;
    banner_name?: string;
    banner_image?: Array<{ id: number; url: string }>;
  }>;
}

const Banner: React.FC<BannerProps> = ({ banners }) => {
  const [randomBanners, setRandomBanners] = useState<Array<any>>([]);

  useEffect(() => {
    if (banners?.length > 3) {
      const shuffled = [...banners].sort(() => Math.random() - 0.5).slice(0, 3);
      setRandomBanners(shuffled);
    } else {
      setRandomBanners(banners);
    }
  }, [banners]);


  return (
    <div className="hide-scrollbar mx-auto flex grid-cols-3 flex-nowrap items-center gap-x-4 overflow-x-auto p-4 lg:grid lg:w-[85%] lg:max-w-screen-xl 2xl:w-11/12">
      {randomBanners.map((banner, index) => {
        const bannerLink = banner?.banner_post_click_url?.startsWith('http')
          ? banner?.banner_post_click_url
          : `https://${banner?.banner_post_click_url}`;

        return (
          <div
            key={banner ? banner.id : `empty-${index}`}
            className="flex h-24 w-full min-w-[21.5rem] items-center justify-center overflow-hidden rounded bg-gray-50 shadow-md md:min-w-fit"
          >
            {banner?.banner_image?.length > 0 ? (
              (() => {
                const imageUrl = banner.banner_image[0]?.url;
                // const isGif = imageUrl?.toLowerCase().endsWith('.gif');
                const imageElement = (
                  <Image
                    src={imageUrl}
                    alt={banner.banner_name ?? 'Banner'}
                    className="size-full bg-center object-fill"
                    width={420}
                    height={140}
                    quality={50}
                    blurDataURL="blur"
                    priority={false}
                    loading="lazy"
                  />
                );

                return banner.banner_post_click_url ? (
                  <Link
                    href={bannerLink}
                    target="_blank"
                    rel={bannerLink.includes('collegehai.com') ? 'opener noreferrer dofollow' : 'opener noreferrer nofollow'}
                    className="size-full"
                  >
                    {imageElement}
                  </Link>
                ) : (
                  imageElement
                );
              })()
            ) : (
              <div className="flex size-full items-center justify-center bg-gray-50"></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Banner;
